module.exports = __webpack_public_path__ + "static/media/check-icon.8bc3737f.svg";